/**
 * @file
 * Auto TOC behavior.
 *
 * Scans [data-auto-toc] wrappers, injects anchor IDs on H3 headings,
 * prepends a navigation menu, and appends scroll-to-top links per section.
 * Scroll-to-top links share the same breakpoint hide class as the nav.
 */

(function (Drupal, once) {
  'use strict';

  var BREAKPOINT_CLASS = {
    sm: 'd-sm-none',
    md: 'd-md-none',
    lg: 'd-lg-none',
    xl: 'd-xl-none',
    always: ''
  };

  function toAnchorId(text) {
    return text
      .toLowerCase()
      .replace(/[áàâã]/g, 'a')
      .replace(/[éèêë]/g, 'e')
      .replace(/[íìîï]/g, 'i')
      .replace(/[óòôõ]/g, 'o')
      .replace(/[úùûü]/g, 'u')
      .replace(/ñ/g, 'n')
      .replace(/ç/g, 'c')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function uniqueId(base, usedIds) {
    var id = base;
    var counter = 2;
    while (usedIds[id]) {
      id = base + '-' + counter;
      counter++;
    }
    usedIds[id] = true;
    return id;
  }

  function initWrapper(wrapper) {
    // Guard: skip if already initialized.
    if (wrapper.dataset.autoTocInit) return;
    wrapper.dataset.autoTocInit = '1';

    var tocEnabled = wrapper.getAttribute('data-toc-enabled') !== '0';
    if (!tocEnabled) return;

    var breakpoint = wrapper.getAttribute('data-toc-breakpoint') || 'sm';
    var hideClass = BREAKPOINT_CLASS.hasOwnProperty(breakpoint)
      ? BREAKPOINT_CLASS[breakpoint]
      : BREAKPOINT_CLASS.sm;

    var headings = wrapper.querySelectorAll('h3');
    if (!headings.length) return;

    var navId = 'auto-toc-nav-' + Math.floor(Math.random() * 99999);
    var usedIds = {};

    // Assign anchor IDs to headings — prefixed with navId to avoid
    // cross-tab collisions when multiple tabs share identical H3 text.
    headings.forEach(function (heading) {
      var base = toAnchorId(heading.textContent.trim());
      heading.setAttribute('id', navId + '--' + uniqueId(base || 'section', usedIds));
    });

    // Build nav.
    var nav = document.createElement('nav');
    nav.setAttribute('id', navId);
    nav.setAttribute('aria-label', Drupal.t('Índice de secciones'));
    nav.className = 'auto-toc__nav' + (hideClass ? ' ' + hideClass : '');

    var ul = document.createElement('ul');
    ul.className = 'auto-toc__nav-list';

    headings.forEach(function (heading) {
      var li = document.createElement('li');
      li.className = 'auto-toc__nav-item';

      var a = document.createElement('a');
      a.className = 'auto-toc__nav-link';
      a.setAttribute('href', '#' + heading.getAttribute('id'));
      a.textContent = heading.textContent.trim();

      li.appendChild(a);
      ul.appendChild(li);
    });

    nav.appendChild(ul);

    // Insert nav after opening H2 if present, otherwise prepend to wrapper.
    var firstH2 = wrapper.querySelector('h2');
    if (firstH2) {
      firstH2.insertAdjacentElement('afterend', nav);
    } else {
      wrapper.insertBefore(nav, wrapper.firstChild);
    }

    // Inject scroll-to-top link after each section (same hide class as nav).
    headings.forEach(function (_heading, index) {
      var scrollTop = document.createElement('div');
      scrollTop.className = 'auto-toc__scroll-top' + (hideClass ? ' ' + hideClass : '');

      var link = document.createElement('a');
      link.className = 'auto-toc__scroll-top-link';
      link.setAttribute('href', '#' + navId);
      link.innerHTML = '<span aria-hidden="true" class="ph ph-arrow-up"></span> ';

      scrollTop.appendChild(link);

      var nextHeading = headings[index + 1] || null;
      if (nextHeading) {
        nextHeading.insertAdjacentElement('beforebegin', scrollTop);
      } else {
        wrapper.appendChild(scrollTop);
      }
    });

    // Smooth scroll for all anchor links inside this wrapper.
    wrapper.addEventListener('click', function (e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;

      var targetId = link.getAttribute('href').substring(1);
      var target = document.getElementById(targetId);

      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (history.pushState) {
          history.pushState(null, null, '#' + targetId);
        }
      }
    });
  }

  Drupal.behaviors.autoToc = {
    attach: function (context) {
      // On page load only process visible wrappers (active tab pane).
      // Hidden tab panes are initialized lazily via shown.bs.tab.
      context.querySelectorAll('[data-auto-toc]').forEach(function (wrapper) {
        if (wrapper.offsetParent !== null) {
          initWrapper(wrapper);
        }
      });

      // Initialize each tab pane the first time it becomes visible.
      once('auto-toc-tab-listener', 'body', context).forEach(function () {
        document.addEventListener('shown.bs.tab', function (e) {
          var targetSelector = e.target.getAttribute('data-bs-target');
          if (!targetSelector) return;
          var pane = document.querySelector(targetSelector);
          if (pane) {
            pane.querySelectorAll('[data-auto-toc]').forEach(initWrapper);
          }
        });
      });
    }
  };

})(Drupal, once);
